export default __webpack_public_path__ + "static/media/cover.55c29b04.jpg";